import { render, staticRenderFns } from "./veStuHygieneItem.vue?vue&type=template&id=ef4bb03c&scoped=true"
import script from "./veStuHygieneItem.vue?vue&type=script&lang=js"
export * from "./veStuHygieneItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4bb03c",
  null
  
)

export default component.exports